import React, { FunctionComponent } from "react";

const LikeIcon: FunctionComponent = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 13 13"
      width="13"
      height="13"
    >
      <path
        d="M11.7248 4.50357H7.38718C7.30275 4.50357 7.2202 4.47866 7.14987 4.43195C7.07954 4.38524 7.02455 4.31881 6.99182 4.24099C6.95908 4.16317 6.95004 4.07741 6.96583 3.99447C6.98162 3.91153 7.02154 3.8351 7.08059 3.77475L8.08669 2.74665L8.95582 1.69951C9.12691 1.51925 9.23263 1.28684 9.25608 1.03943C9.27954 0.792012 9.21938 0.543876 9.08523 0.334673C8.73212 -0.113076 7.97901 -0.111635 7.40603 0.339492L2.39941 4.28281V12.8688H9.93165C10.1098 12.8689 10.2834 12.8129 10.4279 12.7088C10.5724 12.6047 10.6804 12.4577 10.7367 12.2887L12.8239 6.02779C12.8819 5.85367 12.8977 5.66827 12.87 5.48685C12.8422 5.30543 12.7718 5.13319 12.6645 4.98433C12.5571 4.83548 12.416 4.71426 12.2526 4.63067C12.0892 4.54708 11.9083 4.50352 11.7248 4.50357Z"
        fill="currentColor"
      />
      <path
        d="M1.48192 4.49835H0V12.8688H1.48192V4.49835Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default LikeIcon;
